import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showModal } from '../../../features/modal/ducks';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { loanActions } from '../../../common/enums';
import { selectLoans, fetchLoansActions, selectLoansPagination } from '../ducks';
import { apiCallIds } from '../api';
import LoanList from '../components/LoanList';
import { selectAccount, } from '../../auth/ducks';
import Button from 'antd/lib/button';

const AUTO_REFRESH_COOLDOWN_MS = 10 * 60 * 1000;

const activeActions = [loanActions.SIGN_CONTRACT, loanActions.ENTER_SMS_CODE_CONTRACT, loanActions.SIGN_INSURANCE_CONTRACT];

const mapStateToProps = state => ({
  isFetching: selectIsInProgress(state, apiCallIds.FETCH_LOANS),
  loans: selectLoans(state),
  pagination: selectLoansPagination(state),
  account: selectAccount(state)
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchLoans: fetchLoansActions.request,
      showConfirmLoanModal: loanId => showModal({ id: apiCallIds.CONFIRM_LOAN, data: loanId }),
      showSignLoanModal: loan => showModal({ id: apiCallIds.SIGN_LOAN, data: loan }),

      showSignLoanInsuranceModal: loan => showModal({ id: apiCallIds.SIGN_LOAN_INSURANCE, data: loan }),
      showConfirmLoanInsuranceModal: loanId => showModal({ id: apiCallIds.CONFIRM_LOAN_INSURANCE, data: loanId }),
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class LoansContainer extends Component {
  lastAutoRefreshAt = 0;

  static propTypes = {
    actions: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    loans: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { currentPage: 0, visible: false, dateFrom: "", dateTo: "" };
    this.nextButtonHandle = this.nextButtonHandle.bind(this);
    this.previousButtonHandle = this.previousButtonHandle.bind(this);
  }

  componentDidMount() {
    // TODO: add query params to determine, whether to show payment alert or not

    const script = document.createElement("script");
    script.src = "https://amapi.trustpay.eu/mapi5/Scripts/TrustPay/popup.js";
    script.async = true;

    document.body.appendChild(script);
    if (this.props.location.query.cardPayment === 'success'){
      this.setState({cardPaymentSuccess: true})
    }
    else if (this.props.location.query.cardPayment === 'fail'){
      this.setState({cardPaymentSuccess: false})
    }
    else {
      this.setState({cardPaymentSuccess: null})
    }

    this.fetchLoansPage(0, true);
    window.addEventListener('focus', this.handleWindowFocus);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentDidUpdate(prevProps) {
    const previousAccountId = prevProps.account && prevProps.account.id;
    const accountId = this.props.account && this.props.account.id;

    if (previousAccountId && accountId && previousAccountId !== accountId) {
      this.setState({ currentPage: 0 }, () => this.fetchLoansPage(0, true));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('focus', this.handleWindowFocus);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleWindowFocus = () => {
    this.fetchLoansPage(this.state.currentPage);
  };

  handleVisibilityChange = () => {
    if (!document.hidden) {
      this.fetchLoansPage(this.state.currentPage);
    }
  };

  fetchLoansPage = (pageNo, force = false) => {
    const now = Date.now();

    if (!force && now - this.lastAutoRefreshAt < AUTO_REFRESH_COOLDOWN_MS) {
      return;
    }

    this.lastAutoRefreshAt = now;
    this.props.actions.fetchLoans({
      append: false,
      options: pageNo ? { pageNo } : {},
    });
  };

  nextButtonHandle() {
    const currentPage = this.state.currentPage + 1;

    this.setState({ currentPage });
    this.fetchLoansPage(currentPage, true);
    document.documentElement.scrollTop = 0;
  }

  previousButtonHandle() {
    const currentPage = this.state.currentPage - 1;

    this.setState({ currentPage });
    this.fetchLoansPage(currentPage, true);
    document.documentElement.scrollTop = 0;
  }

  render() {
    const { actions, isFetching, loans, account } = this.props;
    const pendingActions = loans.filter(loan => activeActions.includes(loan.action)).length;


    let buttons;
    if (this.state.currentPage > 0) {
      if (loans.length < 20) {
        buttons = <div style={{ marginTop:10 }}>
          <Button size="small" type="primary" onClick={this.previousButtonHandle}>
            Predchádzajúce pôžičky
         </Button>
        </div>;
      } else {
        buttons = <div style={{ marginTop: 10 }}>
        <Button size="small" type="primary" onClick={this.previousButtonHandle}>
          Predchádzajúce pôžičky
         </Button>
        <Button size="small" style={{ float: 'right' }} type="primary" onClick={this.nextButtonHandle}>
          Ďalšie pôžičky
        </Button>
        </div>;
      }
    } else {
      if (loans.length < 20) {
        buttons = <div></div>;
      } else {
        buttons = <div style={{ marginTop: 10 }}>
          <Button size="small" style={{ float: 'right' }} type="primary" onClick={this.nextButtonHandle}>
            Ďalšie pôžičky
         </Button>
        </div>;
      }
    }

    const sortedLoans = [...loans].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    return (
      <div>
        <LoanList
          cardPaymentSuccess={this.state.cardPaymentSuccess}
          isFetching={isFetching}
          pendingActions={pendingActions}
          items={sortedLoans}
          showConfirmLoanModal={actions.showConfirmLoanModal}
          showSignLoanModal={actions.showSignLoanModal}
          showSignLoanInsuranceModal={actions.showSignLoanInsuranceModal}
          showConfirmLoanInsuranceModal={actions.showConfirmLoanInsuranceModal}
          role={account.role}
        />
        {buttons}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/containers/LoansContainer.js